import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, useLocation } from 'react-router-dom';

import { getActiveDocument } from 'redux/actions/documentActions';
import { getActiveDetail } from 'redux/actions/notificationReviewActions';
import { getDownloadUrl } from 'redux/actions/authActions';
import { emptyString } from 'shared/utils';
// eslint-disable-next-line react/prop-types
const PrivateRoute = ({ component, onlyCustomer, onlyClient, ...rest }) => {
  const dispatch = useDispatch();
  const { pathname, search } = useLocation();
  const { cusNavId, authToken, isCustomer } = useSelector((state) => state.auth);
  if (emptyString(cusNavId) && emptyString(authToken)) {
    const params = new URLSearchParams(search);
    if (pathname === '/notificacion_details' && params.toString()) {
      dispatch(getActiveDetail(`${pathname}?${params.toString()}`));
    }
    if (pathname === '/download_document' && params.toString()) {
      dispatch(getDownloadUrl(`${pathname}?${params.toString()}`));
    }
    if (pathname === '/documentations' && params.toString()) {
      dispatch(getActiveDocument(`${pathname}?${params.toString()}`));
    }
    return <Redirect to="/log_in" />;
  }
  if (
    onlyCustomer &&
    !isCustomer &&
    (pathname === rest.path || pathname === rest.computedMatch?.url)
  ) {
    return <Redirect to="/home" />;
  }

  if (onlyClient && isCustomer && pathname === rest.path) {
    return <Redirect to="/home" />;
  }
  return <Route component={component} {...rest} />;
};

export default PrivateRoute;
